import React from 'react';
import { useAuth } from '../context/AuthContext';
import AdminDashboard from '../pages/admin/dashboard/AdminDashboard';
import Dashboard from '../components/dashboard/Dashboard';

// For admins, `/dashboard` mirrors `/admin` so both URLs land on the admin
// dashboard. Everyone else gets the standard student/instructor dashboard.
function DashboardRouter() {
  const { user } = useAuth();
  return user?.role === 'admin' ? <AdminDashboard /> : <Dashboard />;
}

export default DashboardRouter;
